// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gMIS","option":"styles_option__1KwDK","selected":"styles_selected__WaYnx"};